import { addToast } from "./toastService";
import i18n from "../Services/i18n";
/*
    addToast("Succès !", "SUCCESS_001", "SUCCESS", true);
*/
class ServiceHelper {
  static ApiCallPrevalidation() {
    const expireOn = localStorage.getItem("expireOn");
    const token = localStorage.getItem("token");
    if (!token || !expireOn) {
      this.ExpiredSessionToastAndRedirectToLogin();
      return false;
    }

    return true;
  }

  static ApiCallPrevalidateAndGetConfig() {
    const expireOn = localStorage.getItem("expireOn");
    const token = localStorage.getItem("token");
    if (!token || !expireOn) {
      this.ExpiredSessionToastAndRedirectToLogin();
    }

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    return config;
  }

  static ApiCallPostValidation(response, calltype) {
    if (response && response.status === 419) {
      this.ExpiredSessionToastAndRedirectToLogin();
    } else if (response && response.status === 400) {
      addToast(
        i18n.t("Generic.ToastMessage.ExpiredSession"),
        "ApiCallPostValidation",
        "WARNING",
        true,
      );
      addToast(
        i18n.t("Generic.ToastMessage.ExpiredSession"),
        "ApiCallPostValidation",
        "WARNING",
        true,
      );
      return false;
    } else if (response && response.status === 429) {
      addToast(
        "ApiCallPostValidation",
        i18n.t("Generic.ToastMessage.ExpiredSession"),
        "WARNING",
        true,
      );
      return true;
    }
    let msg = "unknown toast msg";
    if (response.data?.code === "PrivilegeValidationFailed") {
      msg = i18n.t(`Privilege.ValidationError.${response.data?.message}`);
    } else {
      switch (calltype) {
        case "upload":
          msg = response.data?.success
            ? i18n.t("Generic.ToastMessage.UploadSucceed")
            : i18n.t("Generic.ToastMessage.UploadFailed");
          break;
        case "create":
          msg = response.data?.success
            ? i18n.t("Generic.ToastMessage.CreateSucceed")
            : i18n.t("Generic.ToastMessage.CreateFailed");
          break;
        case "update":
          msg = response.data?.success
            ? i18n.t("Generic.ToastMessage.UpdateSucceed")
            : i18n.t("Generic.ToastMessage.UpdateFailed");
          break;
        case "delete":
          msg = response.data?.success
            ? i18n.t("Generic.ToastMessage.DeleteSucceed")
            : i18n.t("Generic.ToastMessage.DeleteFailed");
          break;
        case "archive":
          msg = response.data?.success
            ? i18n.t("Generic.ToastMessage.ArchiveSucceed")
            : i18n.t("Generic.ToastMessage.ArchiveFailed");
          break;
        case "unarchive":
          msg = response.data?.success
            ? i18n.t("Generic.ToastMessage.UnarchiveSucceed")
            : i18n.t("Generic.ToastMessage.UnarchiveFailed");
          break;
        default:
          msg = "unknown toast msg";
      }
    }

    const d = new Date();
    addToast(
      msg,
      "postValidationToast" + d.getSeconds() + d.getMilliseconds(),
      response.data?.success ? "SUCCESS" : "ERROR",
      true,
    );
    return response.data?.success;
  }

  static ApiCallPostCatchValidation(error) {
    if (error.response) {
      const status = error.response.status;

      if (status === 401 || status === 419) {
        this.ExpiredSessionToastAndRedirectToLogin();
        return false;
      }

      if (status === 429) {
        addToast(i18n.t("Generic.ToastMessage.ExpiredSession"), "EXPIREDSESSION", "WARNING", true);
        return true;
      }

      addToast(
        i18n.t("Generic.ToastMessage.ServerNotResponding"),
        "SRVNOTRESPONDING",
        "ERROR",
        true,
      );
      return false;
    }

    if (error.request) {
      addToast(
        i18n.t("Generic.ToastMessage.ServerNotResponding"),
        "SRVNOTRESPONDING",
        "ERROR",
        true,
      );
      return false;
    }

    addToast(i18n.t("Generic.ToastMessage.ServerNotResponding"), "SRVNOTRESPONDING", "ERROR", true);
    return false;
  }

  static IsEmptyGuid(value) {
    const normalized = value?.trim().toLowerCase();
    return !normalized || normalized === "00000000-0000-0000-0000-000000000000";
  }

  static ExpiredSessionToastAndRedirectToLogin() {
    window.location.href = "/login?expired";
    localStorage.removeItem("token");
    localStorage.removeItem("expireOn");
    addToast("Session expirée", "ExpiredSession", "WARNING", true);
  }
}

export default ServiceHelper;
